export default "__VITE_ASSET__BcpTy1Qo__"